export const one2OneClassStatus = {
  1:"在读学生",
  2:"已结课学生",
  3:"未开课学生"
}